import styled from 'styled-components';

export const Text = styled.p`
  text-decoration: none;
  margin: 0;
`;

export const Bold = styled(Text)`
  font-weight: bold;
`;
